module.exports = __webpack_public_path__ + "img/mobile/BetBar/btn-sound_off@3x.png?1.0.17";